<template>
  <div id="sidebar" v-bind:class="show_on_mobile ? 'show' : ''" @click="closeMe">
    <div class="center-mobile">
      <div class="group" v-for="group in list">
        <li v-bind:class="(item[1] instanceof RegExp ? item[1].test(path) : item[1] === path) ? 'bold': ''" v-for="item in group">
          <a v-bind:href="item[1]">{{ item[0] }}</a>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/js/event-bus.js";
const path = /localhost/.test(window.location.href) ? `http://localhost:3001` : `https://testing.porticopay.com`

export default {
  name: "Table",
  data () {
    return {
      path: window.location.pathname,
      show_on_mobile: false,
      list: [
        [
          ["Home", "/"],
          ["Create an Organization", "/organizations/create/"],
        ],
        [
          ["Dashboard", `/organizations/me/`],
          ["Testing", `${path}/organizations/me/`],
          ["Analyze", `${path}/organizations/me/analyze/`],
          ["Conversion Funnel", `${path}/organizations/me/conversions/`],
        ],
        [
          ["Docs", `/docs/`],
        ]
      ]
    };
  },

  mounted () {
    EventBus.$on("toggleSidebar", () => {
      console.log('toggle');
      this.$data.show_on_mobile = !this.$data.show_on_mobile;
    });
  },

  methods: {
    closeMe: function (e) {
      if (e.target.id === "sidebar") this.$data.show_on_mobile = false;
    }
  },
};
</script>

<style scoped>
#sidebar {
  text-align: left;
  display: inline-block;
  vertical-align: top;
  position: sticky;
  top: 20px;

  margin-right: 50px;
  margin-top: 30px;
}

li.bold {
  font-weight: bold;
}

li {
  list-style-type: none;
  line-height: 1.8;
}

a {
  text-decoration: none;
}

.group {
  margin-bottom: 30px;
}

@media (max-width: 1500px) {
  #sidebar {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    margin: 0;

    background: #263e52d0;
    text-align: center;

    display: flex;
    align-items: center;
    justify-content: center;

    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease;
  }

  #sidebar.show {

    opacity: 1;
    pointer-events: all;
  }

  #sidebar.show .center-mobile {
    width: 550px;
    display: inline-block;
    text-align: left;
  }

  #sidebar.show .group {
    text-align: left;
    font-size: 3em;
    font-weight: 600;
  }

  #sidebar.show li {
    line-height: 1.2;
  }

  #sidebar.show a {
    color: #fff;
    opacity: 0.7;
  }

  #sidebar.show li.bold a {
    opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/generics/Sidebar.vue